
import React, { useEffect, useState, useContext } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import UserContext from './UserContext';
import HLSPlayer from './HLSPlayer';
import UploadSong from './UploadSong';
import "./ArtistProfile.css";

const ArtistProfile = () => {
  const { username } = useParams();
  const location = useLocation();
  const { user } = useContext(UserContext);
  const [artist, setArtist] = useState(null);
  const [currentSong, setCurrentSong] = useState(null);
  const [showUpload, setShowUpload] = useState(false);
  const [activeQueue, setActiveQueue] = useState([]);
  const [activeQueueType, setActiveQueueType] = useState("uploaded");	
  const [expandedSongId, setExpandedSongId] = useState(null);
  const [commentsBySong, setCommentsBySong] = useState({});
  const [commentDrafts, setCommentDrafts] = useState({});	
  const [uploadedContinuousPlay, setUploadedContinuousPlay] = useState(false);
  const [playlistContinuousPlay, setPlaylistContinuousPlay] = useState(false);
  const [profileBioDraft, setProfileBioDraft] = useState("");
  const [profilePictureFile, setProfilePictureFile] = useState(null);
  const [profileSaveMessage, setProfileSaveMessage] = useState("");
  const [tipJarUrl, setTipJarUrl] = useState("");

  useEffect(() => {
    const fetchArtistData = async () => {
      try {
        const res = await fetch(`/api/artist/${username}/`);
        const data = await res.json();
        setArtist(data);
        setProfileBioDraft(data.bio || "");
        setTipJarUrl(data.tip_jar_url || "");
        if (data.songs && data.songs.length > 0) {
          setCurrentSong(data.songs[0]);
        }
      } catch (err) {
        console.error("Error fetching artist:", err);
      }
    };

    fetchArtistData();
  }, [username]);

  // ✅ ADD: Handle like button
    const handleLike = async (songId, e) => {
  e.stopPropagation();

  if (!user) {
    alert("Please log in to like songs");
    return;
  }

  try {
    const response = await fetch(`/api/songs/${songId}/like/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    setArtist(prevArtist => ({
      ...prevArtist,
      songs: prevArtist.songs.map(song =>
        song.id === songId
          ? { ...song, like_count: data.like_count, user_has_liked: data.liked }
          : song
      ),
    }));

    setCurrentSong(prevCurrentSong =>
      prevCurrentSong && prevCurrentSong.id === songId
        ? {
            ...prevCurrentSong,
            like_count: data.like_count,
            user_has_liked: data.liked,
          }
        : prevCurrentSong
    );
  } catch (error) {
    console.error("Error liking song:", error);
  }
};



  if (!artist) return <div style={{ color: "white", padding: "20px" }}>Loading...</div>;

const isOwnProfile = user && user.username === username;
const searchParams = new URLSearchParams(location.search);
const isEditView = searchParams.get("view") === "edit";
const showOwnerControls = isOwnProfile && isEditView;

  const handlePlayerPlay = (songId, newPlayCount) => {
  setArtist(prevArtist => ({
    ...prevArtist,
    songs: prevArtist.songs.map(song =>
      song.id === songId
        ? { ...song, partial_plays: newPlayCount }
        : song
    )
  }));

  setCurrentSong(prevCurrentSong =>
    prevCurrentSong && prevCurrentSong.id === songId
      ? { ...prevCurrentSong, partial_plays: newPlayCount }
      : prevCurrentSong
  );
};


  const handleSongClick = async (song, queue, queueType) => {
    setActiveQueue(queue);
    setActiveQueueType(queueType);
    setCurrentSong(song);

  try {
    const res = await fetch(`/api/songs/${song.id}/click/`, {
      method: "POST",
    });

    const data = await res.json();

    setArtist(prevArtist => ({
      ...prevArtist,
      songs: prevArtist.songs.map(s =>
        s.id === song.id
          ? { ...s, click_count: data.click_count }
          : s
      )
    }));

    setCurrentSong(prevCurrentSong =>
      prevCurrentSong && prevCurrentSong.id === song.id
        ? { ...prevCurrentSong, click_count: data.click_count }
        : prevCurrentSong
    );

  } catch (err) {
    console.error("click error:", err);
  }
};


const handlePlayerLike = (songId, newLikeCount, newLikedStatus) => {
  setArtist(prevArtist => ({
    ...prevArtist,
    songs: prevArtist.songs.map(song =>
      song.id === songId
        ? { ...song, like_count: newLikeCount, user_has_liked: newLikedStatus }
        : song
    )
  }));

  setCurrentSong(prevCurrentSong =>
    prevCurrentSong && prevCurrentSong.id === songId
      ? {
          ...prevCurrentSong,
          like_count: newLikeCount,
          user_has_liked: newLikedStatus
        }
      : prevCurrentSong
  );
};

const handleAddToPlaylist = async (songId, e) => {
  e.stopPropagation();

  if (!user) {
    alert("Please log in to add songs to your playlist");
    return;
  }

  try {
    const response = await fetch(`/api/songs/${songId}/add-to-playlist/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to add song to playlist");
    }

    alert("Added to playlist");
  } catch (error) {
    console.error("Error adding to playlist:", error);
    alert("Could not add song to playlist");
  }
};

const handleSongEnd = () => {
  const shouldContinue =
    activeQueueType === "uploaded"
      ? uploadedContinuousPlay
      : playlistContinuousPlay;

  if (!shouldContinue) return;
  if (!activeQueue.length || !currentSong) return;

  const currentIndex = activeQueue.findIndex(
    song => song.id === currentSong.id
  );

  if (currentIndex === -1) return;

  const nextIndex =
    (currentIndex + 1) % activeQueue.length;

  setCurrentSong(activeQueue[nextIndex]);
};


const toggleComments = async (songId, e) => {
  e.stopPropagation();

  if (expandedSongId === songId) {
    setExpandedSongId(null);
    return;
  }

  setExpandedSongId(songId);

  if (!commentsBySong[songId]) {
    try {
      const response = await fetch(`/api/songs/${songId}/comments/`);
      const data = await response.json();

      setCommentsBySong(prev => ({
        ...prev,
        [songId]: data,
      }));
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  }
};

const handleCommentDraftChange = (songId, value) => {
  if (value.length > 280) return;

  setCommentDrafts(prev => ({
    ...prev,
    [songId]: value,
  }));
};

const handleSubmitComment = async (songId, e) => {
  e.preventDefault();
  e.stopPropagation();

  if (!user) {
    alert("Please log in to comment");
    return;
  }

  const text = (commentDrafts[songId] || "").trim();
  if (!text) return;

  try {
    const response = await fetch(`/api/songs/${songId}/comments/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ text }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || data.detail || "Could not post comment");
    }

    setCommentsBySong(prev => ({
      ...prev,
      [songId]: [data, ...(prev[songId] || [])],
    }));

    setCommentDrafts(prev => ({
      ...prev,
      [songId]: "",
    }));
  } catch (error) {
    console.error("Error posting comment:", error);
    alert(error.message);
  }
};

const handleProfileUpdate = async (e) => {
  e.preventDefault();

  if (!user) {
    alert("Please log in");
    return;
  }

  const formData = new FormData();
  formData.append("bio", profileBioDraft);
  formData.append("tip_jar_url", tipJarUrl);

  if (profilePictureFile) {
    formData.append("profile_picture", profilePictureFile);
  }

  try {
    const response = await fetch("/api/artist/update/", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Could not update profile");
    }

    setArtist(prev => ({
      ...prev,
      bio: data.bio,
      profile_picture: data.profile_picture,
    }));

    setProfileSaveMessage("Profile updated.");
  } catch (error) {
    console.error("Profile update error:", error);
    setProfileSaveMessage(error.message);
  }
};


  return (
  <div style={{ padding: "20px", color: "black" }}>

    {artist.profile_picture && (
      <img
        src={artist.profile_picture}
        alt={`${artist.username} profile`}
        style={{
          width: "140px",
          height: "140px",
          objectFit: "cover",
          borderRadius: "50%",
          marginBottom: "18px",
          border: "3px solid rgba(255,255,255,0.18)",
        }}
      />
    )}

    <h1>
      {showOwnerControls ? (
        <>
          Hello,{" "}
          <span style={{ color: "#000000" }}>
            {artist.username}
          </span>
        </>
      ) : (
        artist.username
      )}
    </h1>
      
      {showOwnerControls && (
        <div style={{ background: "rgba(255, 215, 0, 0.2)", padding: "10px", marginBottom: "20px" }}>
          <p style={{ color: "#FFD700" }}>You're viewing your own profile!</p>
          <button 
            onClick={() => setShowUpload(!showUpload)}  // ✅ Toggle upload form
            style={{ 
              padding: "10px", 
              background: "#FFD700", 
              border: "none", 
              borderRadius: "5px",
              marginRight: "10px",
              cursor: "pointer"
            }}
          >
            {showUpload ? "Hide Upload" : "Upload Song"}
          </button>
          
          
	     {/* ✅ Show upload form when toggled */}
          {showUpload && <UploadSong />} 

          <form
  onSubmit={handleProfileUpdate}
  style={{ marginTop: "16px", display: "grid", gap: "10px" }}
>
  <textarea
    value={profileBioDraft}
    onChange={(e) => setProfileBioDraft(e.target.value)}
    placeholder="Write a short artist bio..."
    rows="4"
    maxLength="1000"
    style={{
      width: "100%",
      padding: "10px",
      fontFamily: '"Courier New", monospace',
      boxSizing: "border-box",
    }}
  />

  <input
  type="url"
  placeholder="Support link: CashApp, Venmo, Bandcamp, Patreon..."
  value={tipJarUrl}
  onChange={(e) => setTipJarUrl(e.target.value)}
  style={{
    width: "100%",
    padding: "10px",
    fontFamily: '"Courier New", monospace',
    boxSizing: "border-box",
  }}
/>
<p style={{ color: "#888", fontSize: "0.75rem", margin: "0" }}>
  A "SUPPORT ARTIST" button will appear on your profile when this is filled in.
</p>	      
	      
  <input
    type="file"
    accept="image/*"
    onChange={(e) => setProfilePictureFile(e.target.files[0])}
  />

  <button
    type="submit"
    style={{
      padding: "10px",
      background: "#FFD700",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontWeight: "900",
    }}
  >
    Save Profile
  </button>

  {profileSaveMessage && (
    <div style={{ color: "#000000", fontWeight: "900" }}>
      {profileSaveMessage}
    </div>
  )}
</form>
        </div>
      )}
      
        <p
  style={{
    color: "#000000",
    background: "rgba(255,255,255,0.72)",
    padding: "12px",
    borderRadius: "8px",
    maxWidth: "720px",
    lineHeight: "1.5",
  }}
>
  {artist.bio || "No bio yet"}
</p>
    {artist.tip_jar_url && (
  <a 
    href={artist.tip_jar_url}
    target="_blank"
    rel="noopener noreferrer"
    className="tip-jar-btn"
  >
    💰 SUPPORT ARTIST
  </a>
)}
     
       {currentSong && (
        <div style={{ marginBottom: "20px" }}>
          <HLSPlayer
            song={currentSong}
            onSongEnd={handleSongEnd}
            onNext={handleSongEnd}
            onLikeUpdate={handlePlayerLike}
            onPlayUpdate={handlePlayerPlay}
            autoPlay={false}
	    playOnLoad={
            activeQueueType === "uploaded"
            ? uploadedContinuousPlay
            : playlistContinuousPlay
              }
         />
        </div>
      )}


      <h3 style={{ marginBottom: "12px", color: "#000000" }}>
  {showOwnerControls
    ? "My Songs"
    : `${artist.username}'s Songs`}
</h3>
      
      <div className="autoplay-toggle">
  <span className="autoplay-label">
    AUTOPLAY
  </span>

  <button
    type="button"
    className={`autoplay-switch ${uploadedContinuousPlay ? "on" : "off"}`}
    onClick={() => setUploadedContinuousPlay(prev => !prev)}
  >
    <span className={!uploadedContinuousPlay ? "active" : ""}>
      OFF
    </span>

    <span className={uploadedContinuousPlay ? "active" : ""}>
      ON
    </span>
  </button>
</div>

      

              <ul className="song-list">
  {artist.songs.map(song => (
    <li key={song.id}>
      <button
        onClick={() => handleSongClick(song, artist.songs, "uploaded")}
        className="song-row"
      >
        <div className="song-title-block">
          <span className="song-title">
            {song.title}
          </span>
        </div>

 <button
  type="button"
  className="song-disclosure-action"
  title="Show comments"
  onClick={(e) => toggleComments(song.id, e)}
>
  <span></span>
  <span></span>
  <span></span>
</button>

        <div className="song-stats">

	<button
  type="button"
  className="song-strip-action playlist-action"
  title="Add to playlist"
  onClick={(e) => handleAddToPlaylist(song.id, e)}
>
  +LIST
</button>



	<div className="song-like-wrapper">

  <span
    className="song-like-action"
    onClick={(e) => handleLike(song.id, e)}
  >
    {song.user_has_liked ? "LIKED" : "LIKE"}
  </span>

  <span className="song-like-count">
    {song.like_count || 0}
  </span>

</div>


          <span className="song-stat">
            CLICKS <strong>{song.click_count || 0}</strong>
          </span>

          <span className="song-stat">
            PLAYS <strong>{song.partial_plays || 0}</strong>
          </span>
        </div>
      </button>

	{expandedSongId === song.id && (
  <div className="song-comments-panel" onClick={(e) => e.stopPropagation()}>
    <div className="song-comments-list">
      {(commentsBySong[song.id] || []).slice(0, 3).map(comment => (
        <div className="song-comment" key={comment.id}>
          <div className="song-comment-meta">
            {comment.username} · {comment.timestamp}
          </div>

          <div className="song-comment-text">
            {comment.text}
          </div>
        </div>
      ))}

      {commentsBySong[song.id] &&
        commentsBySong[song.id].length === 0 && (
          <div className="song-comment-empty">
            No comments yet.
          </div>
      )}
    </div>

    <form
      className="song-comment-form"
      onSubmit={(e) => handleSubmitComment(song.id, e)}
    >
      <input
        type="text"
        maxLength="280"
        placeholder={user ? "Add a comment..." : "Log in to comment"}
        value={commentDrafts[song.id] || ""}
        onChange={(e) =>
          handleCommentDraftChange(song.id, e.target.value)
        }
        disabled={!user}
      />

      <button type="submit" disabled={!user}>
        POST
      </button>
    </form>
  </div>
)}





    </li>
  ))}
</ul>


      



      {artist.songs.length === 0 && (
        <p style={{ color: "#888" }}>No songs uploaded yet.</p>
      )}

     <h3
  style={{
    marginTop: "35px",
    marginBottom: "12px",
    color: "#000000"
  }}
>
  {showOwnerControls
  ? "My Playlist"
  : `${artist.username}'s Playlist`}
</h3>	

   <div className="autoplay-toggle">
  <span className="autoplay-label">
    AUTOPLAY
  </span>

  <button
    type="button"
    className={`autoplay-switch ${playlistContinuousPlay ? "on" : "off"}`}
    onClick={() => setPlaylistContinuousPlay(prev => !prev)}
  >
    <span className={!playlistContinuousPlay ? "active" : ""}>
      OFF
    </span>

    <span className={playlistContinuousPlay ? "active" : ""}>
      ON
    </span>
  </button>
</div>	  

<ul className="song-list">
  {artist.playlist_songs && artist.playlist_songs.map(song => (
    <li key={`playlist-${song.id}`}>
      <button
        onClick={() =>
          handleSongClick(
            song,
            artist.playlist_songs,
            "playlist"
          )
        }
        className="song-row"
      >
        <div className="song-title-block">
          <span className="song-title">
            {song.title}
          </span>
	           <Link
                to={`/artist/${song.artist_name}?view=public`}
                className="song-artist-link"
                onClick={(e) => e.stopPropagation()}
              >
                by {song.artist_name}
              </Link>
        </div>

        <button
          type="button"
          className="song-disclosure-action"
          title="Show comments"
	  onClick={(e) => toggleComments(song.id, e)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className="song-stats">

          <button
            type="button"
            className="song-strip-action playlist-action"
            title="Add to playlist"
            onClick={(e) => {
              e.stopPropagation();
              alert("Playlist feature coming soon");
            }}
          >
            +LIST
          </button>

          <div className="song-like-wrapper">

            <span
              className="song-like-action"
              onClick={(e) => handleLike(song.id, e)}
            >
              {song.user_has_liked ? "LIKED" : "LIKE"}
            </span>

            <span className="song-like-count">
              {song.like_count || 0}
            </span>

          </div>

          <span className="song-stat">
            CLICKS <strong>{song.click_count || 0}</strong>
          </span>

          <span className="song-stat">
            PLAYS <strong>{song.partial_plays || 0}</strong>
          </span>

        </div>
      </button>

	{expandedSongId === song.id && (
  <div className="song-comments-panel" onClick={(e) => e.stopPropagation()}>
    <div className="song-comments-list">
      {(commentsBySong[song.id] || []).slice(0, 3).map(comment => (
        <div className="song-comment" key={comment.id}>
          <div className="song-comment-meta">
            {comment.username} · {comment.timestamp}
          </div>
          <div className="song-comment-text">
            {comment.text}
          </div>
        </div>
      ))}

      {commentsBySong[song.id] && commentsBySong[song.id].length === 0 && (
        <div className="song-comment-empty">
          No comments yet.
        </div>
      )}
    </div>

    <form
      className="song-comment-form"
      onSubmit={(e) => handleSubmitComment(song.id, e)}
    >
      <input
        type="text"
        maxLength="280"
        placeholder={user ? "Add a comment..." : "Log in to comment"}
        value={commentDrafts[song.id] || ""}
        onChange={(e) => handleCommentDraftChange(song.id, e.target.value)}
        disabled={!user}
      />

      <button type="submit" disabled={!user}>
        POST
      </button>
    </form>
  </div>
)}






    </li>
  ))}
</ul>

    </div>
  );
};

export default ArtistProfile;


